import { render, staticRenderFns } from "./EditMapCategories.vue?vue&type=template&id=480799dd&scoped=true"
import script from "./EditMapCategories.vue?vue&type=script&lang=js"
export * from "./EditMapCategories.vue?vue&type=script&lang=js"
import style0 from "./EditMapCategories.vue?vue&type=style&index=0&id=480799dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480799dd",
  null
  
)

export default component.exports